import { Box, Button, Typography, alpha, darken, lighten } from "@mui/material";
import { usePage } from "../../../layouts";
import { forwardRef, useEffect, useRef, useState } from "react";
import HomeTypography from "../../../features/homepage/theme/HomeTypography";
import { animated, easings, useSpring } from "react-spring";
import { l_footer } from "../Footer/locales";

function ButtonRoundArrowIcon({ darkMode }: { darkMode: boolean }) {
  return (
    <svg width={24} height={25} fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="prefix__buttonroundarrow"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={25}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12.5c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.522-4.478-10-10-10S2 6.978 2 12.5zm1.5 0a8.5 8.5 0 1117.002.002A8.5 8.5 0 013.5 12.5zm6.456 3.024a.75.75 0 001.13.979l3.487-3.471.073-.085a.75.75 0 00-.073-.978l-3.486-3.471-.084-.073a.75.75 0 00-.977.075l-.072.084a.75.75 0 00.074.977l2.952 2.94-2.952 2.939-.072.084z"
          fill="#000"
        />
      </mask>
      <g mask="url(#prefix__buttonroundarrow)">
        <path fill={darkMode ? "#1A2045" : "#fff"} d="M0 .5h24v24H0z" />
      </g>
    </svg>
  );
}

const AnimatedBox = animated(Box);

const AdsButton = ({ darkMode }: { darkMode: boolean }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let scrollEL = () => {
      if (window.scrollY < 30) {
        setIsScrolled(false);
      } else {
        setIsScrolled(true);
      }
    };

    addEventListener("scroll", scrollEL);

    return () => {
      removeEventListener("scroll", scrollEL);
    };
  }, []);

  const propsBox = useSpring({
    opacity: isScrolled ? 1 : 0,
    config: { duration: 400, easing: easings.easeInOutQuint },
  });

  return (
    <AnimatedBox
      key="ads-container"
      id="ads-container"
      style={{ ...propsBox }}
      className="mui-fixed"
      sx={{
        position: "fixed",
        // background: "yellow",
        width: "100%",
        bottom: { xs: "24px", md: "32px", lg: "40px" },
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          maxWidth: "1800px",
          width: "90%",
          margin: "auto",
          // background: "lightblue",
          zIndex: 1000,
        }}
      >
        <Button
          href="./contacts"
          sx={{
            background: darkMode ? "white" : "black",
            borderRadius: "24px",
            textTransform: "none",
            paddingX: "36px",
            gap: "8px",
            transition: "all",
            zIndex: 1000,
            ":hover": {
              backgroundColor: darkMode
                ? darken("#fff", 0.06)
                : lighten("#000", 0.12),
            },
          }}
        >
          <HomeTypography
            variant="body1"
            sx={{
              color: darkMode ? "#1A2045" : "white",
              fontWeight: 600,
            }}
          >
            {l_footer("adsButton.buttonTxt")}
          </HomeTypography>
          <ButtonRoundArrowIcon darkMode={darkMode} />
        </Button>
      </Box>
    </AnimatedBox>
  );
};

export default AdsButton;
